import {
  RequiredActionCondition,
  FetchRequiredActionConditionsAction,
  FetchRequiredActionConditionsSuccessAction,
  FetchRequiredActionConditionsFailAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function fetchRequiredActionConditions(applicationId: string): FetchRequiredActionConditionsAction {
  return { type: REDUX_STORE.REQUIRED_ACTION_CONDITIONS.ACTION_TYPES.FETCH_REQUIRED_ACTION_CONDITIONS, applicationId };
}

export function fetchRequiredActionConditionsSuccess(
  requiredActionConditions: RequiredActionCondition[]
): FetchRequiredActionConditionsSuccessAction {
  return {
    type: REDUX_STORE.REQUIRED_ACTION_CONDITIONS.ACTION_TYPES.FETCH_REQUIRED_ACTION_CONDITIONS_SUCCESS,
    requiredActionConditions,
  };
}

export function fetchRequiredActionConditionsFail(message: string): FetchRequiredActionConditionsFailAction {
  return { type: REDUX_STORE.REQUIRED_ACTION_CONDITIONS.ACTION_TYPES.FETCH_REQUIRED_ACTION_CONDITIONS_FAIL, message };
}
